const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
    selectedLanguage:localStorage.getItem("Language")
    ? localStorage.getItem("Language")
    : "en",
    user:localStorage.getItem("User")
    ? localStorage.getItem("User")
    : null,
};

const slice = createSlice({
    name:"language",
    initialState,
    reducers:{
        languageAction(state,action){
            state.selectedLanguage = action.payload;
            localStorage.setItem("Language", state.selectedLanguage);
        },
        userAction(state,action){
            state.user = action.payload;
            localStorage.setItem("User", state.user);
        },
        userLogout(state,action){
            state.user = null;
            localStorage.setItem("User", state.user);


        }
    }
})

export const {languageAction, userAction, userLogout} = slice.actions;
export default slice.reducer;